var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "signUp" },
    [
      _c("ProgressBarForSignUp", {
        attrs: {
          "current-phase": _vm.currentPhase,
          "phase-list": _vm.PHASE_LIST,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "singUpCard" },
        [
          _c("SendAuthCode", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.currentPhase === _vm.PHASE_LIST.SEND_AUTH_CODE.number,
                expression: "currentPhase === PHASE_LIST.SEND_AUTH_CODE.number",
              },
            ],
            staticClass: "sendAuthCode",
            on: { "goto-next": _vm.gotoInputAuthCode },
          }),
          _vm._v(" "),
          _c("InputAuthCode", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.currentPhase === _vm.PHASE_LIST.INPUT_AUTH_CODE.number,
                expression:
                  "currentPhase === PHASE_LIST.INPUT_AUTH_CODE.number",
              },
            ],
            staticClass: "inputAuthCode",
            attrs: {
              "mail-address": _vm.mailAddress,
              "error-get-mail-address": _vm.errorGetMailAddress,
            },
            on: {
              "goto-next": _vm.gotoInputUserData,
              "fix-email": _vm.fixEmail,
            },
          }),
          _vm._v(" "),
          _c("InputUserData", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.currentPhase === _vm.PHASE_LIST.INPUT_USER_DATA.number,
                expression:
                  "currentPhase === PHASE_LIST.INPUT_USER_DATA.number",
              },
            ],
            staticClass: "inputUserData",
            attrs: {
              "prev-page-type": _vm.prevPageType,
              "mail-address": _vm.mailAddress,
              "is-previous-page-action-complete":
                _vm.isPreviousPageActionComplete,
              "hash-key": _vm.hashKey,
              "action-user-info": _vm.actionUserInfo,
            },
            on: { "goto-next": _vm.gotoComplete },
          }),
          _vm._v(" "),
          _c("Complete", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentPhase === _vm.PHASE_LIST.COMPLETE.number,
                expression: "currentPhase === PHASE_LIST.COMPLETE.number",
              },
            ],
            staticClass: "complete",
            attrs: { "prev-page-type": _vm.prevPageType },
          }),
          _vm._v(" "),
          _c("Error", {
            attrs: {
              "is-open": _vm.isOpenMailPermissionFailedDialog,
              title: "パーミッションの更新に失敗しました。",
              "detail-error-list": [
                "一部の会員情報更新に失敗しました。プロフィール画面から再度お試しください。",
              ],
              persistent: "",
              "button-custom-text": "閉じる",
            },
            on: { "click-dialog-button": _vm.closeDialog },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }